module.exports = __webpack_public_path__ + "img/nateev-sem-slogan.5fb4245b.svg";